import { useSnackbar } from 'notistack';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useParams } from 'react-router-dom';
import { PrivilegeService } from 'api';
import Spinner from 'components/Spinner/Spinner';
import { CUSTOMERS } from 'routes/customers/paths';
export default function ActivatePrivilege() {
  const {
    t
  } = useTranslation();
  const {
    push
  } = useHistory();
  const {
    enqueueSnackbar
  } = useSnackbar();
  const {
    token
  } = useParams();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    async function activatePrivilege() {
      if (!token) return;
      try {
        setLoading(true);
        const body = {
          tokenValue: token
        };
        await PrivilegeService.activatePrivilege({
          body
        });
        enqueueSnackbar(t('privileges.success'), {
          variant: 'success'
        });
      } catch (e) {
        enqueueSnackbar(t('error.adding_privilege'), {
          variant: 'error'
        });
      } finally {
        setLoading(false);
        push(CUSTOMERS);
      }
    }
    activatePrivilege();
  }, [enqueueSnackbar, push, t, token]);
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  return null;
}